import { User } from '@yandex-lego/user';
import { getRequestContext } from '@/shared/lib/requestContext';

export const AccountAvatar = () => {
    const { account } = getRequestContext();
    const avatarId = account.avatarId;
    const { platform, yandexPassportEnv } = getRequestContext();

    if (!account.loggedIn) {
        return null;
    }

    return <User platform={platform} avatarSize={40} userData={{ avatarId }} env={yandexPassportEnv} />;
};
